import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { PagePaginationResponseDtoSchema, responseContract } from '../../lib';

const _GetStaffingRatioTableRequestDtoSchema = z.object({
  from: z.string(),
  to: z.string(),
  page: z.number().optional(),
  perPage: z.number().optional(),
  facilitiesIds: z.array(z.number()).optional(),
});

const FacilityStaffingRatioDtoSchema = z.object({
  facilityId: z.number(),
  facilityName: z.string(),
  ratioValue: z.number().nullable(),
  metric: z.enum(['RATIO', 'HPRD']).optional(),
  isOverstaffed: z.boolean(),
  isUnderstaffed: z.boolean(),
  avgStaff: z.number().nullable(),
  avgResidents: z.number().nullable(),
});

const GetStaffingRatioTableResponseDtoSchema = PagePaginationResponseDtoSchema(
  FacilityStaffingRatioDtoSchema
);

export type GetStaffingRatioTableRequestDto = z.infer<
  typeof _GetStaffingRatioTableRequestDtoSchema
>;
export type GetStaffingRatioTableResponseDto = z.infer<
  typeof GetStaffingRatioTableResponseDtoSchema
>;
export type FacilityStaffingRatioDto = z.infer<
  typeof FacilityStaffingRatioDtoSchema
>;

export const getStaffingRatioTable = (
  params: GetStaffingRatioTableRequestDto,
  config?: AxiosRequestConfig<GetStaffingRatioTableRequestDto>
) => {
  return api
    .get('/staff/staffing-ratio-table', {
      params,
      ...config,
    })
    .then(responseContract(GetStaffingRatioTableResponseDtoSchema));
};
